import { api } from '../core';

export interface DocumentProviderAddNewResponse {
  newProviderId: string;
}

interface DocumentProviderAddNewProps {
  documentId: string;
  providerName: string;
  providerType: string; // 'TRUST' | 'GP' | 'HOSPITAL'; // (specified by user)
  invalidateData?: boolean;
}

const documentProviderAddNewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentProviderAddNew: builder.query<DocumentProviderAddNewResponse, DocumentProviderAddNewProps>({
      query: ({ documentId, providerName, providerType }: DocumentProviderAddNewProps) => ({
        url: `document/provider/add/new`,
        method: 'POST',
        body: {
          document_id: documentId,
          provider_name: providerName,
          provider_type: providerType
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Error in postDocumentProviderAddNew in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentProviderAddNewQuery } = documentProviderAddNewApi;
